module.exports = __webpack_public_path__ + "img/hero-illustration.df9d06a0.svg";